import { useParams, Link } from "react-router-dom";
import { packages } from "../data/packages";
import RecommendedPackages from "../components/RecommendedPackages";
import { getAverageRating } from "../utils/ratings"; // only need average
import "./PackageDetails.css";

export default function PackageDetails() {
  const { category, id } = useParams();

  // Safe ID comparison
  const pkg = packages[category]?.find((p) => String(p.id) === id);

  if (!pkg) return <p className="not-found">Package not found</p>;

  const descriptionLines = pkg.longDescription?.split("\n") || [];

  // Static rating only
  const avgRatingRaw = getAverageRating(pkg.reviews);
  const avgRating = avgRatingRaw > 0 ? Math.round(avgRatingRaw) : 4; // default 4 stars if no rating

  return (
    <section className="package-details">

      {/* PACKAGE DETAIL */}
      <div className="package-detail-card">
        <div className="detail-layout">

          {/* Image */}
          <div className="detail-image-wrapper">
            <img src={pkg.image} alt={pkg.title} className="detail-image" />
            <div className="image-caption">
              {category.toUpperCase()} PACKAGE
            </div>
          </div>

          {/* TEXT */}
          <div className="detail-text">
            <h2>{pkg.title}</h2>

            {/* ⭐ STAR RATING ONLY */}
            <div className="rating">
              {[...Array(5)].map((_, i) => (
                <span
                  key={i}
                  className={`star ${i < avgRating ? "filled" : ""}`}
                >
                  ★
                </span>
              ))}
            </div>

            {/* Description */}
            <div className="description">
              {descriptionLines.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>

            {/* Buttons */}
            <div className="detail-actions">
              <Link to="/contact" className="btn-readmore">
                Customize This Package
              </Link>

              <Link to={`/packages/${category}`} className="btn-back">
                ← Back to {category.charAt(0).toUpperCase() + category.slice(1)} Packages
              </Link>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}